import {PolIcon} from "components/PolIcon/policon";
import React from 'react';
import {Link} from "react-router-dom";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function QuoteTasksNewButton({quoteId, prospectId, closePopup}) {
    const {t} = usePolTranslation();
    const { getRouteByNativeIdentifier } = useNavigation();
    return (
        <Link to={{
            pathname: `/${resolveUrl(getRouteByNativeIdentifier('detail_open_tasks')?.url, {prospect: prospectId})}/add`,
            state: {relaunchId: quoteId}
        }}>
            <div onClick={closePopup}
                 className="prospect-tab__prospect__header__action task">
                <PolIcon icon='plus'/>
                <span>{t('new_task')}</span>
            </div>
        </Link>
    )
}
